var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
import { Checkbox, Button } from '../..';
const ContentWrapper = styled.span `
  display: inline-flex;
  align-items: center;
  > *:first-child {
    margin-right: 0.5rem;
  }
`;
const buttonMapping = {
    Primary: {
        element: Button.OutlinePrimary,
        checkedButtonColor: 'PRIMARY_300',
    },
    Basic: {
        element: Button.OutlineBasic,
        checkedButtonColor: 'INK_200',
    },
};
const ButtonComponent = (props) => {
    const { CheckboxButtonKey } = props, restProps = __rest(props, ["CheckboxButtonKey"]);
    const SpeificButton = buttonMapping[CheckboxButtonKey].element;
    return React.createElement(SpeificButton, Object.assign({}, restProps));
};
const StyledWrapper = styled.span `
  > button {
    padding-left: 0.5rem;
    &:hover:not(:disabled) input[type='checkbox'] + div {
      border: 0.0625rem solid
        ${({ theme, CheckboxButtonKey }) => theme.colors[theme.checkbox.types[CheckboxButtonKey].activeBorder]};
    }
    &:hover input[type='checkbox'] + div * {
      fill: ${({ theme, CheckboxButtonKey }) => theme.colors[theme.checkbox.types[CheckboxButtonKey].svg.hover]};
      color: ${({ theme, CheckboxButtonKey }) => theme.colors[theme.checkbox.types[CheckboxButtonKey].svg.hover]};
    }

    ${({ checked }) => checked &&
    css `
        &.is-focus svg {
          fill: ${({ theme }) => theme.colors.SNOW_100};
          > path {
            fill: ${({ theme }) => theme.colors.SNOW_100};
          }
        }
      `}
    &:not(:active) {
      background-color: ${({ theme, checked, checkedButtonColor }) => checked ? theme.colors[checkedButtonColor] : ''};
    }
  }
`;
const checkboxButtonGenerator = (CheckboxButtonKey) => (_a) => {
    var { children, onChange, isError, interminate, checked, disabled, innerRef } = _a, restProps = __rest(_a, ["children", "onChange", "isError", "interminate", "checked", "disabled", "innerRef"]);
    const CheckboxComponent = Checkbox[CheckboxButtonKey];
    return (React.createElement(StyledWrapper, { checked: checked, CheckboxButtonKey: CheckboxButtonKey, checkedButtonColor: buttonMapping[CheckboxButtonKey].checkedButtonColor },
        React.createElement(ButtonComponent, Object.assign({}, restProps, { CheckboxButtonKey: CheckboxButtonKey, disabled: disabled }),
            React.createElement(ContentWrapper, { CheckboxButtonKey: CheckboxButtonKey },
                React.createElement(CheckboxComponent, { checked: checked, interminate: interminate, isError: isError, disabled: disabled, onChange: onChange, ref: innerRef }),
                children))));
};
export const Basic = React.forwardRef((props, ref) => {
    const CheckboxButton = checkboxButtonGenerator('Basic');
    return React.createElement(CheckboxButton, Object.assign({ innerRef: ref }, props));
});
export const Primary = React.forwardRef((props, ref) => {
    const CheckboxButton = checkboxButtonGenerator('Primary');
    return React.createElement(CheckboxButton, Object.assign({ innerRef: ref }, props));
});
//# sourceMappingURL=CheckboxButton.js.map